import { createReducer } from 'redux-act';
import { fromJS } from 'immutable';
import createActions from 'modules/create-actions';

export const initialState = fromJS({
  allItems: [],
  selectedItemIndex: null,
  lastKeyboardSelectedItemIndex: null,
  direction: null,
});

export const Actions = createActions('SearchBar', [
  'resetSelections', 'storeAllItems', 'selectItemByDirection', 'selectItemByIndex',
]);

const selectItemByDirection = (state, { direction, filteredLength: numItems }) => {
  const currentItem = state.get('selectedItemIndex');
  let selectedItem;
  if (direction === 1) {
    if (currentItem === numItems - 1) {
      selectedItem = null;
    } else {
      if (currentItem === null) {
        selectedItem = 0;
      } else {
        selectedItem = currentItem + 1;
      }
    }
  } else {
    if (direction === -1) {
      if (currentItem === 0) {
        selectedItem = null;
      } else {
        if (currentItem === null) {
          selectedItem = numItems - 1;
        } else {
          selectedItem = currentItem - 1;
        }
      }
    }
  }
  return selectedItem;
};

export const reducer = createReducer({
  [Actions.resetSelections](state) {
    return state
      .set('selectedItemIndex', null)
      .set('lastKeyboardSelectedItemIndex', null);
  },

  [Actions.storeAllItems](state, allItems) {
    return state
      .set('allItems', allItems);
  },

  [Actions.selectItemByDirection](state, payload) {
    const index = selectItemByDirection(state, payload);
    return state
      .set('direction', payload.direction)
      .set('selectedItemIndex', index)
      .set('lastKeyboardSelectedItemIndex', index);
  },

  [Actions.selectItemByIndex](state, index) {
    return state
      .set('direction', 0)
      .set('selectedItemIndex', index);
  },

}, initialState);



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/reducer.js
 **/